import React, { Component } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from './Components/LoginPage/Login';
import PoDetails from './Components/PoDetails/Podetails';
import SideBar from './Components/SideBar/SideBar';
import PoDetailsEdit from './Components/PoDetailsEdit/PoDetailsEdit';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/PoDetails" element={<PoDetails />} />
          <Route path="/SideBar" element={<SideBar />} />
          <Route path="/PoDetailsEdit" element={<PoDetailsEdit />} />
          {/* <Route path="/Overview" element={<Overview />} /> */}

        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
